import { render, staticRenderFns } from "./RegisterBind.vue?vue&type=template&id=d736bd52"
import script from "./RegisterBind.vue?vue&type=script&lang=js"
export * from "./RegisterBind.vue?vue&type=script&lang=js"
import style0 from "./RegisterBind.vue?vue&type=style&index=0&id=d736bd52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports